import React from "react";
import ReactLoading from "react-loading";
import "./Loading.scss";

export default function Loading(props) {
  return (
    <>
      {props.show && (
        <div className="divLoading">
          <ReactLoading
            type={props.type}
            color={props.color}
            height={"50px"}
            width={"50px"}
            className="loading"
          />
        </div>
      )}
    </>
  );
}
